import gutterStyle, {breakpoints} from './utils';
import {isNullOrUndefined, getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    let {
    children, span, className, order,
    gutter, offset, push, pull, style
} = self.get();

const {xs, sm, md, lg, xl} = self;

let hasGutter = gutter > 0;
if (hasGutter) {
    style = gutterStyle(gutter, style, 'padding');
}

const classNameObj = {
    'k-col': true,
    [`k-${span}`]: span,
    [className]: className && !hasGutter,
    [`k-offset-${offset}`]: offset > 0,
    [`k-pull-${pull}`]: pull,
    [`k-push-${push}`]: push,
    [`k-order-${order}`]: order,
};
// add responsive class
breakpoints.forEach(item => {
    const obj = self[item];
    if (!obj) return;
    const prefix = item === 'xs' ? 'k-' : `k-${item}-`;
    if (!isNullOrUndefined(obj.span)) {
        classNameObj[`${prefix}${obj.span}`] = true;
    }
    ['order', 'offset', 'pull', 'push'].forEach(prop => {
        if (!isNullOrUndefined(obj[prop])) {
            classNameObj[`${prefix}${prop}-${obj[prop]}`] = true;
        }
    });
});

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'style': function() {try {return (style )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (hasGutter ?
        h('div', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (className )} catch(e) {_e(e)}}.call($this))) :
        children
    )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}